import classNames from 'classnames'
import Link from 'next/link'
import { Fragment } from 'react'
import Card from 'react-bootstrap/Card'

import { AuthorType } from '@/types/wordpress'

import styles from './AuthorBio.module.scss'

type Props = {
  author: AuthorType
  noClick?: boolean
}

const AuthorBio = ({ author, noClick }: Props) => {
  const Wrapper: React.ElementType = noClick ? Fragment : Link
  const wrapperProps = noClick ? {} : { href: `/articles/author/${author.slug}` }

  return (
    <Card className={classNames(styles.container, 'shadow-sm')}>
      <Wrapper {...wrapperProps}>
        <img alt={author.name} src={author.avatarUrl} />
      </Wrapper>
      <div>
        <Wrapper {...wrapperProps}>
          <h3 className='m-2 text-gray'>{author.name}</h3>
        </Wrapper>
        {author.description && (
          <>
            <hr />
            <p className='m-0'>{author.description}</p>
          </>
        )}
      </div>
    </Card>
  )
}

export default AuthorBio
